import React, { useEffect, useState } from "react";
import { Container, Button, Spinner, Col, Row } from "react-bootstrap";
import apiClient from "../RedProveedores/apiClient";
import { Download, Info } from "lucide-react";
import PdfViewer from "./PdfViewer";
import axios, { AxiosRequestConfig } from "../axios-config";
import Swal from "sweetalert2";
import { Encriptar } from "../Util/Encripcion.js";
import axiosSomit from "../axios-config";
const CarnetDigital = () => {
  const [imagenBase64, setImagenBase64] = useState(null);
  const [pdfBase64, setPdfBase64] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        let datos = {
          //NIT = 1, CUI = 2, Poliza = 3
          intCodTipoBusqueda: 3,
          //NIT, CUI, Poliza,
          strBusqueda: sessionStorage.getItem("numeroPolizaAseg"),
          //El valor es obligatorio si la consulta es por Póliza
          strCertificado: sessionStorage.getItem("numeroCertificado") == 'undefined' ? '' : sessionStorage.getItem("numeroCertificado"),
          codigoAseguradora: sessionStorage.getItem("codigoAseguradora")
        };
        let datosEncriptados = Encriptar(JSON.stringify(datos));
        const respuesta = await axiosSomit.post(
          `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/ConsultaCarnet`,
          datosEncriptados,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("jwtToken")}`,
            },
          }
        );
        if (respuesta.data.data.strCarnet != "null") {
          setPdfBase64(respuesta.data.data.strCarnet);
        } else {
          //setPdfBase64(undefined);
          alert(respuesta.data.data.strMensaje);
          /*Swal(
            "Atención",
            respuesta.data.data.strMensaje,
            "warning"
          );*/
        }


      } catch (error) {
        console.error("Error cargando los datos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const descargarPDF = () => {
    const link = document.createElement("a");
    link.href = `data:application/pdf;base64,${pdfBase64}`;
    link.download = "carnet_" + sessionStorage.getItem("numeroPolizaAseg") + "_" + sessionStorage.getItem("numeroCertificado") + ".pdf";
    link.click();
  };

  return (
    <Container className="mt-4 text-center">
      {/*<h3  style={{ color: "rgb(135, 36, 52)", fontWeight: "bold" }}>Carnet Digital</h3>*/}

      {loading ? (
        <Spinner animation="border" />
      ) : (
        <>
          {pdfBase64 ? (
            /*<iframe
              title="Carnet PDF"
              src={`data:application/pdf;base64,${pdfBase64}`}
              width="100%"
              height="500px"
            />*/
            <div style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}>
              <PdfViewer pdfBase64={pdfBase64} />
            </div>
          ) : (
            <p style={{ color: "green" }}><Info size={24} /> Su carnet no se encuentra disponible en este momento.</p>
          )}

          {pdfBase64 && (
            <Row>
              <Col size={6}>
                <Button
                  style={{
                    marginTop: "20px",
                    backgroundColor: "rgb(0, 52, 121)",
                    color: "#FFFFFF",
                  }}
                  onClick={descargarPDF}
                >
                  <Download size={18} /> Descargar PDF
                </Button>
              </Col>
            </Row>

          )}
        </>
      )}
    </Container>
  );
};

export default CarnetDigital;
